import { useCallback } from 'react';
import {
  EVENT_BANNER_LIST,
  EVENT_HOME_BANNER_LIST,
} from '../domain/event/EventListData';

const useEvent = () => {
  const isEventItemOn = useCallback(({ startDate, endDate }) => {
    const today = +new Date();
    const dayOfEndDate = +new Date(endDate || '2999-12-31T00:00:00');
    const dayOfStartDate = +new Date(startDate);

    const isHomeBannerOn = dayOfEndDate >= today && today >= dayOfStartDate;
    const isMaskOn = today > dayOfEndDate;
    const isEventBannerOn = today >= dayOfStartDate;
    return { isHomeBannerOn, isMaskOn, isEventBannerOn };
  }, []);

  const eventHomeBannerList = EVENT_HOME_BANNER_LIST.filter((el) => {
    const { startDate, endDate } = el.period;
    const { isHomeBannerOn } = isEventItemOn({ startDate, endDate });
    return isHomeBannerOn;
  });

  const filterByIsClosedEventList = useCallback(
    (isClosed) =>
      EVENT_BANNER_LIST.filter((item) => {
        const { isMaskOn } = isEventItemOn({ endDate: item.period.endDate });
        return isMaskOn === isClosed;
      }),
    [],
  );

  const onGoingEventList = filterByIsClosedEventList(false);

  const maskOnEventList = filterByIsClosedEventList(true).sort(function (a, b) {
    const dateA = new Date(a.period.endDate);
    const dateB = new Date(b.period.endDate);
    return +dateB - dateA;
  });

  return {
    onGoingEventList,
    maskOnEventList,
    eventHomeBannerList,
    isEventItemOn,
  };
};

export default useEvent;
